// Galician translations
export const gl: Record<string, string> = {
  'menu.dashboard': 'Panel de control',
  'menu.customers': 'Clientes',
  'menu.products': 'Produtos',
  'menu.users': 'Usuarios',
  'menu.settings': 'Configuración',
  'menu.logout': 'Pechar sesión',
  'dashboard.title': 'Panel de control',
  'dashboard.newOrder': 'Novo pedido',
  'order.title': 'Novo pedido',
  'order.customer': 'Cliente',
  'order.products': 'Produtos',
  'order.total': 'Total',
  'users.title': 'Usuarios',
  'users.name': 'Nome',
  'users.email': 'Correo electrónico',
  'common.yes': 'Si',
  'common.no': 'Non',
  'common.cancel': 'Cancelar',
  'common.save': 'Gardar',
  'common.search': 'Buscar',
  'common.perPage': 'Per Page',
  'common.page': 'Page',
  'common.orders': 'Orders',
  'common.previous': 'Previous',
  'common.next': 'Next',
  'common.pieces': 'pieces',
  'login.title': 'Cleandy',
  'login.login': 'Iniciar sesión',
  'login.welcome': 'Benvido, {name}',
  'login.tagline': 'Dry cleaning software — Smart and easy solutions for your business.',
  'signup.email': 'Correo electrónico',
  'signup.phone': 'Teléfono',
  'menu.reportsAndAccounting': 'Informes e contabilidade',
  'menu.systemAndCommunication': 'Sistema e comunicación',
};